module.exports = __webpack_public_path__ + "static/media/Biotif-Bold.35809f4e.ttf";